if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
  this.form = this.querySelector('.js-product-form');

  if (this.form) {
    this.cartDrawer = document.querySelector('cart-drawer');

    if (theme.settings.afterAtc !== 'no-js') {
      this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    const shrubChoice = this.form.querySelector('.pw-shrub-shipping-choice');

    if (shrubChoice) {
      const radios = shrubChoice.querySelectorAll('.pw-shrub-shipping-radio');
      const shipWeekContainer = shrubChoice.querySelector('.pw-shrub-ship-week');
      const shipWeekSelect = shrubChoice.querySelector('.spring-ship-week-selector');
      const shippingGroup = shrubChoice.querySelector('.pw-shrub-shipping-group');

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          const isPreorder =
            radio.dataset.shippingGroup === 'spring_pre_order';

          if (shippingGroup) {
            shippingGroup.value = isPreorder
              ? 'spring_pre_order'
              : 'ship_now';
          }

          if (shipWeekContainer && shipWeekSelect) {
            if (isPreorder) {
              shipWeekContainer.hidden = false;
              shipWeekContainer.style.display = '';
              shipWeekSelect.disabled = false;
            } else {
              shipWeekContainer.hidden = true;
              shipWeekContainer.style.display = 'none';
              shipWeekSelect.disabled = true;
              shipWeekSelect.value = '';
            }
          }
        });
      });
    }
  }
}

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      this.submitBtn = this.querySelector('[name="add"]');

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

const newShippingGroup = formData.get('properties[_shipping_group]');
const newShippingOption = formData.get('properties[Shipping Option]');

const getShippingGroup = (item) => {
  const group = item.properties?._shipping_group;

  if (group) return group;

  const option = item.properties?.['Shipping Option'];

  if (option === 'Ship Now') return 'ship_now';
  if (option === 'Spring Pre-Order') return 'spring_pre_order';

  return null;
};

const currentGroup =
  newShippingGroup ||
  (newShippingOption === 'Ship Now'
    ? 'ship_now'
    : newShippingOption === 'Spring Pre-Order'
      ? 'spring_pre_order'
      : null);


const existingShippingGroups = oldCartData.items
  .map(getShippingGroup)
  .filter(Boolean);


if (
  currentGroup &&
  existingShippingGroups.length > 0 &&
  existingShippingGroups.some(group => group !== currentGroup)
) {
  const message =
    currentGroup === 'ship_now'
      ? 'Ship Now items cannot be combined with items that have a selected ship week. Please place these in a separate order.'
      : 'Items with a selected ship week cannot be combined with Ship Now items. Please place these in a separate order.';

  this.setErrorMsgState(message);
  this.submitBtn.classList.remove('is-loading');
  this.submitBtn.removeAttribute('aria-disabled');

  this.dispatchEvent(new CustomEvent('on:cart:error', {
    bubbles: true,
    detail: { error: message }
  }));

  return;
}

// Keep all Spring Pre-Order items in the cart on the same ship week.
const newShipWeek = formData.get('properties[Estimated Ship Week]')?.trim();

if (currentGroup === 'spring_pre_order' && !newShipWeek) {
  alert('Please choose an estimated ship week before adding this plant to your cart.');

  const shipWeekSelector = this.form.querySelector('.spring-ship-week-selector');
  if (shipWeekSelector) shipWeekSelector.focus();

  this.submitBtn.classList.remove('is-loading');
  this.submitBtn.removeAttribute('aria-disabled');

  return;
}

if (currentGroup === 'spring_pre_order' && newShipWeek) {
  const springItems = oldCartData.items.filter((item) => {
    return getShippingGroup(item) === 'spring_pre_order';
  });

  for (const item of springItems) {
    const existingShipWeek = item.properties?.['Estimated Ship Week'];

    if (existingShipWeek && existingShipWeek !== newShipWeek) {
      const updatedProperties = {
        ...(item.properties || {}),
        'Estimated Ship Week': newShipWeek
      };

      const changeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: updatedProperties
        })
      });

      if (!changeResponse.ok) {
        throw new Error('Unable to update the existing ship week.');
      }
    }
  }
}
        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent
          }
        }));

        if (this.cartDrawer) this.cartDrawer.refresh(true);
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);

}
